import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { COLORS, FONTS } from '../theme';
import { GALLERY, IMAGES, TESTIMONIALS } from '../data/siteData';
import { Section, SectionHeading, Reveal, ImageBox, Icon, Wave } from './common';

export function Gallery() {
  return (
    <Section id="gallery" bg="#fff" sx={{ pt: { xs: 4, md: 6 } }}>
      <Container maxWidth="lg">
        <SectionHeading
          eyebrow="Our Gallery"
          title="Little Moments, Big Smiles"
          subtitle="A peek into the colourful and cheerful days at St Lord's Day Care."
          color={COLORS.orange}
        />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
            gridAutoRows: { xs: 150, md: 210 },
            gridAutoFlow: 'dense',
            gap: { xs: 1.5, md: 2.5 },
          }}
        >
          {GALLERY.map((g, i) => (
            <Reveal key={g.label} direction="zoom" delay={(i % 4) * 100} sx={{ gridRow: g.tall ? 'span 2' : 'span 1', height: '100%' }}>
              <Box
                sx={{
                  position: 'relative',
                  height: '100%',
                  borderRadius: '30px',
                  overflow: 'hidden',
                  border: `5px solid ${g.color}`,
                  boxShadow: `0 10px 0 ${g.color}55`,
                  cursor: 'pointer',
                  '& img, & > div:first-of-type': { transition: 'transform .6s ease' },
                  '&:hover img, &:hover > div:first-of-type': { transform: 'scale(1.12)' },
                  '&:hover .cap': { transform: 'translateY(0)', opacity: 1 },
                }}
              >
                <ImageBox src={IMAGES.gallery[i]} label={g.label} color={g.color} ratio={null} radius={0} />
                <Box
                  className="cap"
                  sx={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    p: 1.5,
                    bgcolor: g.color,
                    color: '#fff',
                    fontFamily: FONTS.heading,
                    fontWeight: 800,
                    fontSize: 18,
                    textAlign: 'center',
                    transform: 'translateY(100%)',
                    opacity: 0,
                    transition: 'transform .4s ease, opacity .4s ease',
                  }}
                >
                  {g.label}
                </Box>
              </Box>
            </Reveal>
          ))}
        </Box>
      </Container>
      <Wave color={COLORS.cream} sx={{ mt: 6, mb: '-2px' }} />
    </Section>
  );
}

export function Testimonials() {
  return (
    <Section id="testimonials" bg={COLORS.cream} sx={{ pt: { xs: 4, md: 6 } }}>
      <Container maxWidth="lg">
        <SectionHeading
          eyebrow="Happy Parents"
          title="Words from Our Parent Family"
          subtitle="Sample reviews shown here. Replace them with real parent feedback."
          color={COLORS.pink}
        />
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 4 }}>
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} direction="up" delay={i * 150} sx={{ height: '100%' }}>
              <Box
                sx={{
                  position: 'relative',
                  height: '100%',
                  bgcolor: '#fff',
                  borderRadius: '32px 32px 32px 8px',
                  p: 3.5,
                  pt: 5,
                  border: `4px solid ${t.color}`,
                  boxShadow: `0 14px 30px ${t.color}33`,
                  transition: 'transform .3s ease',
                  '&:hover': { transform: 'translateY(-10px) rotate(-1deg)' },
                }}
              >
                <Box sx={{ position: 'absolute', top: -26, left: 28, width: 54, height: 54, borderRadius: '50%', bgcolor: t.color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: FONTS.heading, fontWeight: 800, fontSize: 44, lineHeight: 1, pt: 1.2 }}>
                  &ldquo;
                </Box>
                <Box sx={{ display: 'flex', gap: 0.3, mb: 1.5 }}>
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Icon key={s} name="star" sx={{ color: COLORS.yellow, fontSize: 24 }} />
                  ))}
                </Box>
                <Typography sx={{ fontSize: 16, lineHeight: 1.75, fontStyle: 'italic' }}>{t.text}</Typography>
                <Typography sx={{ mt: 2.5, fontFamily: FONTS.heading, fontWeight: 800, fontSize: 17, color: t.color }}>{t.name}</Typography>
              </Box>
            </Reveal>
          ))}
        </Box>
      </Container>
      <Wave color={COLORS.navy} sx={{ mt: 6, mb: '-2px' }} />
    </Section>
  );
}
